import React from 'react';
import PropTypes from 'prop-types';
import { EyeOutlined } from '@ant-design/icons';

function BoardSearchDropdownItem({
  item: {
    title: cardTitle,
    number: cardNumber,
    board: cardBoard,
    status: cardStatus,
    id: cardId,
  } = {},
  onViewClick,
}) {
  const handleViewClick = (e) => {
    e.stopPropagation();
    onViewClick(cardId);
  };

  return (
    <>
      <div>
        {cardNumber && `#${cardNumber}`}
        <div 
          className="header-container-redesign"
          onClick={handleViewClick}
          style={{
            float: 'right',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <EyeOutlined style={{ fontSize: 16, color: '#2E4355' }} />
        </div>
      </div>
      <div className="board-search-item-title">{cardTitle}</div>
      <div>
        {cardBoard}
        {' '}
        -
        {' '}
        {cardStatus}
      </div>
    </>
  );
}

BoardSearchDropdownItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    number: PropTypes.number,
    board: PropTypes.string,
    status: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onViewClick: PropTypes.func.isRequired,
};

export default BoardSearchDropdownItem;
